__turbopack_context__.v({
  "card": "ppSqyG_card",
  "colorGreen": "ppSqyG_colorGreen",
  "colorRed": "ppSqyG_colorRed",
  "content": "ppSqyG_content",
  "iconWrapper": "ppSqyG_iconWrapper",
  "wrapper": "ppSqyG_wrapper",
});
